import { defineNuxtPlugin, reactive, readonly, useLogger, useRequestEvent } from "#imports";
import { isAllowedCookie } from "../utils/api-cookie.js";
import { appendResponseHeader } from "h3";
export default defineNuxtPlugin({
  name: "backend-api-cookies",
  dependsOn: ["logger"],
  setup() {
    const logger = useLogger();
    if (!import.meta.server) {
      return {
        provide: {
          apiCookies: {
            cookieValues: readonly({}),
            registerServerSideSetCookies: () => {
              logger.warn(new Error("Not implemented on client side"));
            }
          }
        }
      };
    }
    const cookieValues = reactive({});
    const event = useRequestEvent();
    function registerServerSideSetCookies(response) {
      response.headers.getSetCookie().forEach((header) => {
        const cookieParts = header.split("=");
        if (cookieParts.length < 2) {
          return;
        }
        const cookieName = cookieParts[0].trim();
        if (isAllowedCookie(cookieName) && !cookieValues[cookieName]) {
          const valueParts = cookieParts[1].split(";");
          if (!valueParts.length) {
            return;
          }
          cookieValues[cookieName] = valueParts[0].trim();
          appendResponseHeader(event, "set-cookie", header);
        }
      });
    }
    return {
      provide: {
        apiCookies: {
          cookieValues: readonly(cookieValues),
          registerServerSideSetCookies
        }
      }
    };
  }
});
